import { format, startOfDay } from 'date-fns'

export const formatDateForApi = (date: Date) => {
  const dateAtMidnight = startOfDay(date)
  const apiFormattedDate = format(dateAtMidnight, 'yyyy-MM-dd HH:mm:ss')

  return apiFormattedDate
}
